import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { PolizaEntity } from '../../entities/polizas_cliente_entity';
import { PolizaVAM, ConsultaSiniestralidad } from '../../entities/vam_entities';


declare var jQuery: any;

@Injectable()
export class SiniestralidadEmpresaServices {
    private url = "siniestralidad";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaSiniestralidadVAMEmpresa(poliza: PolizaVAM): Observable<ConsultaSiniestralidad>{
       
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json',
        'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaSiniestralidad/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    exportarSiniestralidadVAMEmpresa(poliza: PolizaVAM):Observable<any>{
        let  body  =  JSON.stringify(poliza);
        let  headers  =  new  Headers({
            'Content-Type':  'application/json',
            'Accept':  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let  options  =  new  RequestOptions({ headers:  headers  });
        options.responseType  =  ResponseContentType.Blob;;
        return this.authHttp.post(this.url + "/exportarExcelSiniestralidad/", body, options)
            .map(response => response).catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/siniestralidad/siniestralidad.service.ts